export enum KanbanActionType {
  NONE = 'NONE',
  INITIAL = 'INITIAL',
  DRAG_AND_DROP = 'DRAG_AND_DROP',
  NO_DRAG_AND_DROP = 'NO_DRAG_AND_DROP',
}

export enum DataType {
  CardType = 'card',
  GroupType = 'group',
  ColumnType = 'column',
}
